// extracted by mini-css-extract-plugin
export default {"mainTr":"TableRowCancer_mainTr__da-dR","mainTd":"TableRowCancer_mainTd__gYDGk","hoverRow":"TableRowCancer_hoverRow__QS0gn","inactiveTd":"TableRowCancer_inactiveTd__nfM8F"};